import classNames from 'classnames'
import React from 'react'
import {
  RegisterOptions,
  UseFormRegister,
  useFormContext,
} from 'react-hook-form'

export const TextInput = ({
  name,
  register,
  label,
  description,
  rules,
  defaultValue = '',
  labelClassName,
  inputClassName,
  descriptionClassName,
  placeholder,
  type = 'text',
}: {
  name: string
  register: UseFormRegister<any>
  label?: string
  description?: string
  rules?: RegisterOptions
  defaultValue?: string
  labelClassName?: string
  inputClassName?: string
  descriptionClassName?: string
  placeholder?: string
  type?: string
}) => {
  const {
    formState: { errors },
  } = useFormContext()
  return (
    <div className="flex w-full flex-col gap-y-1">
      {label && (
        <label className="mb-1 flex flex-col gap-y-1" htmlFor={name}>
          <p className={classNames('text-sm', labelClassName)}>{label}</p>
          {description && (
            <p
              className={classNames(
                'text-xs text-gray-500',
                descriptionClassName
              )}
            >
              {description}
            </p>
          )}
        </label>
      )}
      <input
        id={name}
        {...register(name, rules)}
        defaultValue={defaultValue}
        placeholder={placeholder}
        type={type}
        className={classNames(
          'block rounded-md border border-gray-300 px-2.5 py-1',
          errors[name] ? 'border-red-500' : 'border-gray-300',
          inputClassName
        )}
      />
      {errors[name] && (
        <p
          className="mt-0.5 whitespace-nowrap text-xs text-red-600"
          id={`${name}-error`}
        >
          {errors[name]?.message?.toString()}
        </p>
      )}
    </div>
  )
}
